module.exports = __webpack_public_path__ + "img/check-blk.75f8de22.svg";